// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DisruptorPromoCard_wrapper__6WJLG","description":"DisruptorPromoCard_description___w3v5","action":"DisruptorPromoCard_action__o86o2"};